import * as larvitar from "larvitar/dist/larvitar";

const csTools = larvitar.cornerstoneTools;
const getNewContext = csTools.importInternal("drawing/getNewContext");
const draw = csTools.importInternal("drawing/draw");
const setShadow = csTools.importInternal("drawing/setShadow");
const drawRect = csTools.importInternal("drawing/drawRect");
const drawHandles = csTools.importInternal("drawing/drawHandles");

class RectangleRoiNoTextTool extends csTools.RectangleRoiTool {
  constructor(props = {}) {
    super(props);
    this.name = "RectangleRoiNoText";
  }

  renderToolData(evt) {
    const toolData = csTools.getToolState(evt.currentTarget, this.name);
    if (!toolData) return;

    const eventData = evt.detail;
    const { element } = eventData;
    const {
      handleRadius,
      drawHandlesOnHover,
      hideHandlesIfMoving,
      renderDashed,
      drawHandles: shouldDrawHandles
    } = this.configuration;
    const lineDash = csTools.getModule("globalConfiguration").configuration
      .lineDash;
    const context = getNewContext(eventData.canvasContext.canvas);

    draw(context, context => {
      for (let i = 0; i < toolData.data.length; i++) {
        const data = toolData.data[i];
        if (data.visible === false || !data.handles) continue;

        const color = csTools.toolColors.getColorIfActive(data);
        const handleOptions = {
          color,
          handleRadius,
          drawHandlesIfActive: drawHandlesOnHover,
          hideHandlesIfMoving
        };
        setShadow(context, this.configuration);

        const rectOptions = { color };
        if (renderDashed) rectOptions.lineDash = lineDash;

        drawRect(
          context,
          element,
          data.handles.start,
          data.handles.end,
          rectOptions,
          "pixel",
          data.handles.initialRotation
        );

        if (shouldDrawHandles !== false) {
          drawHandles(context, eventData, data.handles, handleOptions);
        }
      }
    });
  }
}

export default RectangleRoiNoTextTool;
